import { Component, OnInit, Output, EventEmitter, OnDestroy } from '@angular/core';

import { Constants } from '../../../helper/constants';
import { Subscription } from 'rxjs';
import { GlobalObservables } from '../../../../../app.global.observer';
import { HelperService } from '../../../services/helper.service';
import { Global } from '../../../../../app.global';
import { KeyDescriptionViewModel } from '../../../viewmodels/keyDescriptionViewModel';

import { DispensationCopy } from '../../../helper/textcopy/policies.text';
import { RadioQuestionModel, SelectQuestionModel } from '../../../viewmodels/policy-item.model';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'dispensation-policy',
  templateUrl: './dispensation.component.html',
})
export class DispensationComponent implements OnInit, OnDestroy {
  // eslint-disable-next-line @angular-eslint/no-output-on-prefix
  @Output() onSavePolicies = new EventEmitter();
  policiesAnswersSetted = new Subscription();
  policiesAnswers: any = this.global.policiesAnswers;

  textCopy = DispensationCopy;
  constants = Constants;
  dispensation = new RadioQuestionModel();
  pcnCancellation = new SelectQuestionModel();

  constructor(
    public global: Global,
    private globalObs: GlobalObservables,
    private helpServ: HelperService
  ) {}

  ngOnInit() {
    this.setDispensationRadioQuestion();
    this.setPcnCancellationSelectQuestion();

    if (this.helpServ.isEmpty(this.policiesAnswers)) {
      this.onPoliciesAnswersSetted();
    } else {
      this.setSelectedValues();
    }
  }

  setDispensationRadioQuestion() {
    this.dispensation.data = {
      title: this.textCopy.validDispensation,
      includeTitle: true,
      beforeText: '',
      afterText: '',
      answers: [
        {
          text: 'yes',
          value: 'y',
        },
        {
          text: 'yes – provided it was displayed (even if it was wrongly displayed)',
          value: 'd',
        },
        {
          text: 'no',
          value: 'n',
        },
      ],
    };
  }
  onDispensationSelected(answerValue) {
    this.dispensation.valueSelected = answerValue;
  }

  setPcnCancellationSelectQuestion() {
    this.pcnCancellation.data = {
      title: this.textCopy.pcnCancellation,
      includeTitle: true,
      answers: [
        {
          id: '0',
          value: '1',
        },
        {
          id: '1',
          value: '2',
        },
        {
          id: '2',
          value: '3',
        },
      ],
    };
  }
  onPcnCancellationSelected(answerValue) {
    this.pcnCancellation.valueSelected = answerValue;
  }

  setSelectedValues() {
    this.dispensation.valueSelected = this.policiesAnswers['2_1'];
    this.pcnCancellation.valueSelected = this.policiesAnswers['2_2'];
  }

  onPoliciesAnswersSetted() {
    this.policiesAnswers = this.global.policiesAnswers;
    this.policiesAnswersSetted = this.globalObs.onPoliciesAnswersSetted.subscribe(() => {
      this.setSelectedValues();
    });
  }

  submitPolicyCategory() {
    let policyList = new Array<KeyDescriptionViewModel>();
    policyList = [
      { id: '2_1', description: this.dispensation.valueSelected },
      { id: '2_2', description: this.pcnCancellation.valueSelected },
    ];

    this.onSavePolicies.emit(policyList);
  }

  ngOnDestroy() {
    if (this.helpServ.isEmpty(this.policiesAnswers)) {
      this.policiesAnswersSetted.unsubscribe();
    }
  }
}
